module.exports = __webpack_public_path__ + "static/hinted-AvenirNext-Medium.34027d75.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/hinted-AvenirNext-Medium.woff2
// module id = 204
// module chunks = 104101334113578 114276838955818